import { type BaseParams, type CollectionSearchResults, type GeneralSearchResults, links, Request } from '@app/client';
import { apiReturnResults } from '@app/client/apiFactory/apiReturn';

export const getGlobalSearchResults = (params: BaseParams & { searchQuery: string }) =>
    Request.getRequest<GeneralSearchResults>({
        ...params,
        target: links.globalSearch().search(params.searchQuery),
        apiSettingsType: 'gs',
    });

export const getCollectionSearchResults = (params: BaseParams & { searchQuery: string }) =>
    Request.getRequest<CollectionSearchResults>({
        ...params,
        target: links.globalSearch().collectionSearch(params.searchQuery),
        apiSettingsType: 'gs',
    });
export const callGetGlobalSearchResults = (params: BaseParams & { searchQuery: string }) => {
    if (!params.searchQuery.length) return;
    return apiReturnResults<GeneralSearchResults>(getGlobalSearchResults, params);
};

export const callGetCollectionSearchResults = (params: BaseParams & { searchQuery: string }) => {
    if (!params.searchQuery.length) return;
    return apiReturnResults<CollectionSearchResults>(getCollectionSearchResults, params);
};
